"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var NoShipToStore = function NoShipToStore(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#666' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size,
      _ref$langContext = _ref.langContext,
      langContext = _ref$langContext === void 0 ? {} : _ref$langContext;
  var iconSize = size === 'original' ? 'width="24.6" height="24.6"' : 'width="100%"';
  var translate = langContext.translate;

  translate = translate || function (text) {
    return text;
  };

  var title = translate('Ship to Store Not Available Icon');
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 24.6 24.6\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M19.6,8.5l2-2,1,.5ZM16.8,4.2,13.4,2.5,8.1,4.8l5.4,2.7Zm-2.2,9.3v8.6L22.8,18V9l-7.2,3.6Zm-9,2V12.8l1.8.9,4.8-4.8L4.8,5.1l-1-.5V17.2ZM11.1,17v5.1l1.7.9V15.3ZM24.6,1.4,23.2,0,0,23.2l1.4,1.4Z\"\n        style=\"fill: ").concat(color, "\"\n      />\n    </svg>\n  ");
};

var _default = NoShipToStore;
exports["default"] = _default;